module.exports = require("./fr-NE.d.ts");